import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const isProduction = import.meta.env.PROD;
const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const posthogEnabled = Boolean(isProduction && posthogKey);
const app = <App posthogEnabled={posthogEnabled} />;

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {isProduction && posthogKey ? (
      <PostHogProvider
        apiKey={posthogKey}
        options={{
          api_host: import.meta.env.VITE_PUBLIC_POSTHOG_API_HOST,
          ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_UI_HOST,
          debug: false,
          name: "rulebase-beam-web",
          enable_recording_console_log: true,
        }}
      >
        {app}
      </PostHogProvider>
    ) : (
      app
    )}
  </StrictMode>
);
